import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Select from "react-select";
import ReactLoading from "react-loading";
import trash from "./../../../../Assets/Images/trash.png";
import upload from "../../../../Assets/Images/upload.png";
import Navbar from "../../../../Components/Navbar/Navbar";
import "./../PurchaseRequest.css";
import { Fragment } from "react";
import InputError from "../../../../Components/InputError/InputError";
import { Upload} from "antd";
import Moment from "moment";
import { getBranchId, getType, numberFormat, toastStyle } from "../../../../Helpers/Utils/Common";
import { createPurchaseRequest, getPurchaseRequest } from "../../../../Helpers/apiCalls/Purchases/purchaseRequestApi";
import { validatePurchaseRequest, validatePurchaseRequestItems } from "../../../../Helpers/Validation/Purchase/PurchaseRequestValidation";
import { getAllEmployees } from "../../../../Helpers/apiCalls/employeesApi";
import { getDepartment } from "../../../../Helpers/apiCalls/departmentApi";
import { getAllBranches } from "../../../../Helpers/apiCalls/Purchases/purchaseOrderApi";
import FileExceedModal from "../../../../Components/Modals/FileExceedModal";
import Compressor from "compressorjs";
import Footer from "../../../../Components/Footer/Footer";
const { Dragger } = Upload;

function AddPurchaseRequest() {
    const { id } = useParams();
    const accountType = getType();
    let navigate = useNavigate();
    const [inactive, setInactive] = useState(true);
    const [isChanged, setIsChanged] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const [isClickedSave, setIsClickedSave] = useState(false);
    const [items, setItems] = useState([
        { description: "", quantity: 0, current_qty: 0, uom: "", remarks: "", purchase_request_remark: "", selling_price: 0, total: 0 },
        { description: "", quantity: 0, current_qty: 0, uom: "", remarks: "", purchase_request_remark: "", selling_price: 0, total: 0 },
        { description: "", quantity: 0, current_qty: 0, uom: "", remarks: "", purchase_request_remark: "", selling_price: 0, total: 0 },
    ]);
    const [allDepartment, setAllDepartment] = useState([]);
    const [allEmployees, setAllEmployees] = useState([]);
    const [allOIC, setAllOIC] = useState([]);
    const [allBranches, setAllBranches] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [showFileExceedModal, setShowFileExceedModal] = useState(false);
  const [itemError, setItemError] = useState({})

    //ERROR HANDLING
    const [isError, setIsError] = useState({
        department_id: false,
        employee_id: false,
        request_date: false,
        required_date: false,
        quantity: false,
        itemList: false,
    });
    const [addDetails, setAddDetails] = useState({
        name: "",
        oic: "",
        description: "",
        branch: "",
        department_id: "",
        requested_by: "",
        request_date: Moment(new Date(), 'YYYY-MM-DD').format('yyyy-MM-DD'),
        pr_no: "",
        remarks: ""
    })
    
    //DISABLE SCROLL FUNCTION
    function limitScroll() {
        var numericInputs = document.querySelectorAll(".numeric-input");
        numericInputs.forEach(function (input) {
        input.addEventListener("wheel", function (e) {
            e.preventDefault();
        });
        });
    }
    limitScroll();
    
    const handleAddChange = (e, type) => {
        if(type === "select") {
            setAddDetails((prevState) => ({
                ...prevState,
                [e.for]: e.value,
                [e.select_value]: {
                    for: e.for,
                    label: e.label,
                    value: e.value,
                }
            }));
        } else {
            const { name, value } = e.target;
            setAddDetails((prevState) => ({
            ...prevState,
            [name]: value,
            }));
        }
    }

    function handleAddItem() {
        const newItem =  { item: "", qty: 0, current_qty: 0, uom: "", remarks: "", purchase_request_remark: "", selling_price: 0, total: 0 };
        setItems((prevItems) => [...prevItems, newItem]);
    }

    function handleItemsChange(e, row, select) {
        setIsChanged(true);
        var temp = items;
        if (select) {
            temp[row].item_id_value = { label: e.label, value: e.value };
            temp[row].item_id = e.value;

        } else {
            const { name, value } = e.target;
            temp[row][name] = value;
            if (name === "quantity" || name === "selling_price") {
                var quantity = temp[row].quantity ? temp[row].quantity : 0
                var price = temp[row].selling_price ? temp[row].selling_price : 0
                var total = quantity * price;
                temp[row]["total"] = total;
            }
        }
        setItems(temp);
        setTimeout(() => setIsChanged(false), 1);
    }

    function handleRemoveItem(row) {
        setIsChanged(true);

        const updatedOrderList = [...items];
        updatedOrderList.splice(row, 1);
        setItems(updatedOrderList);

        setTimeout(() => setIsChanged(false), 10);
    }

    function renderTable() {
        return (
            <Table>
                <thead>
                    <tr>
                        <th className="color-gray">
                            quantity
                        </th>
                        <th className="color-gray">
                            unit
                        </th>
                        <th className="color-gray">
                            complete item description
                        </th>
                        <th className="color-gray">
                            selling price
                        </th>
                        <th className="color-gray">
                            remarks
                        </th>
                        <th className="color-gray">
                            action
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => {
                        return (
                            <tr key={item.id}>
                                <td>
                                    <Form.Control
                                        type="number"
                                        name="quantity"
                                        className="hide-spinner numeric-input"
                                        value={item.quantity}
                                        onChange={(e) =>
                                            handleItemsChange(e, index, false)
                                        }
                                    />
                                    {itemError[index] && itemError[index].quantity && (
                                        <div className="validity-error callout bottom">{itemError[index].quantity}</div>
                                    )}
                                </td>
                                <td>
                                    <Form.Control
                                        type="text"
                                        name="uom"
                                        value={item.uom}
                                        onChange={(e) =>
                                            handleItemsChange(e, index, false)
                                        }
                                    />
                                    {itemError[index] && itemError[index].uom && (
                                        <div className="validity-error callout bottom">{itemError[index].uom}</div>
                                    )}
                                </td>
                                <td>
                                    <Form.Control
                                        type="text"
                                        name="description"
                                        value={item.description}
                                        onChange={(e) =>
                                            handleItemsChange(e, index, false)
                                        }
                                    />
                                    {itemError[index] && itemError[index].description && (
                                        <div className="validity-error callout bottom">{itemError[index].description}</div>
                                    )}
                                    
                                    {/* <Select
                                        options={itemsOptions}
                                        defaultValue={item.item_id_value}
                                        name="item_id"
                                        placeholder="Choose item"
                                        onChange={(e) =>
                                            handleItemsChange(e, index, true)
                                        }
                                        search={true}
                                    /> */}
                                </td>
                                <td>
                                    <Form.Control
                                        type="number"
                                        name="selling_price"
                                        className="hide-spinner numeric-input"
                                        value={item.selling_price}
                                        onChange={(e) =>
                                            handleItemsChange(e, index, false)
                                        }
                                    />
                                    {itemError[index] && itemError[index].selling_price && (
                                        <div className="validity-error callout bottom">{itemError[index].selling_price}</div>
                                    )}
                                </td>
                                <td>
                                    <Form.Control
                                        type="text"
                                        name="remarks"
                                        value={item.remarks}
                                        onChange={(e) =>
                                            handleItemsChange(e, index, false)
                                        }
                                    />
                                </td>
                                <td>
                                    <img
                                        src={trash}
                                        alt="trash"
                                        onClick={() => handleRemoveItem(index)}
                                        className="cursor-pointer"
                                    />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        );
    }

    const handleBeforeUpload = (file) => {
        if (file.size > 2000000) {
            setShowFileExceedModal(true);
        } else {
            //COMPRESSING FILE
            new Compressor(file, {
                quality: 0.6,
                success: (compressedResult) => {
                    setFileList([...fileList, compressedResult]);
                },
            });
        }
        return false;
    };

    const handleRemove = (selectedFile) => {

        var newlist = fileList.filter((file) => {
            return selectedFile.uid !== file.uid;
        });
        setFileList(newlist);
    };

    async function fetchDepartment() {
        setAllDepartment([]);
        const response = await getDepartment({});
        if(response.data) {
            var data = response.data?.data?.map((data) => {
                var info = data;
                info.for = "department_id";
                info.select_value = "department_id_value";
                info.label = data.name;
                info.value = data.id;
                return info
            })
            setAllDepartment(data);
        }
    }

    async function fetchEmployees() {
        setAllEmployees([]);
        const response = await getAllEmployees();
        if(response.data) {
            var arrayResponse = [...response.data.data]
            var data = arrayResponse.map((data) => {
                var info = {};
                info.for = "requested_by";
                info.select_value = "employee_id_value";
                info.label = data.first_name + " " + data.last_name;
                info.value = data.id;
                return info
            })
            setAllEmployees(data);


            var oic = arrayResponse.filter((data) => { return data.employee_type === "officer in charge"})
            .map((data) => {
                var info = {};
                info.for = "oic";
                info.select_value = "oic_id_value";
                info.label = data.first_name + " " + data.last_name;
                info.value = data.first_name + " " + data.last_name;
                return info
            })
            setAllOIC(oic);
        }
    }

    async function fetchBranches() {
        setAllBranches([]);
        const response = await getAllBranches();

        if (response.data) {
            var tempBranches = response.data.data.map((branch) => {
                var info = {};
                    info.for = "branch_id";
                    info.select_value = "branch_id_value";
                    info.label = branch.name;
                    info.value = branch.id;
                return info
            });
            if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
                var filteredBranch = tempBranches.filter((data) => {
                return data.value === getBranchId()
                })
                setAllBranches(filteredBranch);
            } else {
                setAllBranches(tempBranches);
            }
        } 
    }
    
    async function handleSubmit() {
        var errors = validatePurchaseRequestItems(items)
        setItemError(errors)

        if (validatePurchaseRequest(addDetails, items, setIsError) && Object.keys(errors).length === 0) {
            setIsClicked(true);
            const response = await createPurchaseRequest(addDetails, items, fileList, "submitted");
            if(response.data) {
                toast.success(response.data.message, {
                    style: toastStyle(),
                });
                setTimeout(() => {
                    navigate("/purchaserequest");
                }, 1000);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
                setTimeout(() => {
                    // refreshPage()
                    setIsClicked(false);
                }, 1000);
            }
        } else {
            toast.error("Please Fill In All Required Fields!", { style: toastStyle() });
        }
    }

    async function handleSave() {
        var errors = validatePurchaseRequestItems(items)
        setItemError(errors)

        if (validatePurchaseRequest(addDetails, items, setIsError) && Object.keys(errors).length === 0) {
            setIsClickedSave(true);
            const response = await createPurchaseRequest(addDetails, items, fileList, "pending");
            if(response.data) {
                toast.success(response.data.message, {
                    style: toastStyle(),
                });
                setTimeout(() => {
                    navigate("/purchaserequest");
                }, 1000);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
                setTimeout(() => {
                    // refreshPage()
                    setIsClicked(false);
                }, 1000);
            }
        } else {
            toast.error('Please Fill In All Required Fields!', { style: toastStyle() });
        }
    }

    useEffect(() => {
        fetchEmployees()
        fetchDepartment()
        fetchBranches()
    }, [])

    useEffect(() => {
        var _subtotal = items
        .map((item) => parseFloat(item.total))
        .reduce((a, b) => a + b, 0);

        var _grandTotal = _subtotal;
        setAddDetails((prev) => {
            return {
                ...prev,
                subtotal: _subtotal.toFixed(2),
                grand_total: _grandTotal.toFixed(2),
            };
        });
    }, [isChanged]);

    return (
        <div>
            <Toaster position="top-right" reverseOrder={false} />
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"PURCHASES"}
                />
            </div>
            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> 
                            ADD PURCHASE REQUEST
                        </h1>
                    </Col>
                </Row>
                <div className="edit-form">
                    <Row className="mb-3">
                        <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                            <span className="edit-label">
                                Department Name{" "}
                                <label className="badge-required">{` *`}</label>
                            </span>
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                placeholder="Select Department..."
                                value={addDetails.department_id_value}
                                options={allDepartment}
                                onChange={(e) => handleAddChange(e, "select")}
                            />
                            <InputError
                                isValid={isError.department_id}
                                message={"Deparment Name is required"}
                            />
                        </Col>
                        <Col xs={12} lg={3} className="mt-4 mt-lg-0">
                            <span className="edit-label">
                                Request Date{" "}
                                <label className="badge-required">{` *`}</label>
                            </span>
                            <Form.Control
                                type="date"
                                name="request_date"
                                className="nc-modal-custom-text"
                                value={addDetails.request_date}
                                onChange={(e) => handleAddChange(e)}
                            />
                            <InputError
                                isValid={isError.request_date}
                                message={"Request date is required"}
                            />
                        </Col>
                        <Col xs={12} lg={3} className="mt-4 mt-lg-0">
                            <span className="edit-label">
                                Required Date{" "}
                                <label className="badge-required">{` *`}</label>
                            </span>
                            <Form.Control
                                type="date"
                                name="required_date"
                                className="nc-modal-custom-input"
                                defaultValue={addDetails.required_date}
                                onChange={(e) => handleAddChange(e)}
                            />
                            <InputError
                                isValid={isError.required_date}
                                message={"Required date is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12} lg={4}>
                            <span className="edit-label ">OIC/Head</span>
                            {/* <Form.Control
                                type="text"
                                name="oic"
                                value={addDetails.oic}
                                className="nc-modal-custom-input"
                                // disabled
                                onChange={(e) => handleAddChange(e)}
                            /> */}
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                placeholder="Select OIC..."
                                value={addDetails.oic_id_value}
                                options={allOIC}
                                onChange={(e) =>
                                    handleAddChange(e, "select")
                                }
                            />
                        </Col>
                        <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                            <span className="edit-label ">Branch
                                <label className="badge-required">{` *`}</label>
                            </span>
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                placeholder="Select Branch..."
                                value={addDetails.branch_id_value}
                                options={allBranches}
                                onChange={(e) => handleAddChange(e, "select")}
                            />
                            <InputError
                                isValid={isError.branch_id}
                                message={"Branch is required"}
                            />
                        </Col>
                        <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                            <span className="edit-label">
                                Requested by{" "}
                                <label className="badge-required">{` *`}</label>
                            </span>
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                placeholder="Select Employee..."
                                value={addDetails.employee_id_value}
                                options={allEmployees}
                                onChange={(e) =>
                                    handleAddChange(e, "select")
                                }
                            />
                            <InputError
                                isValid={isError.requested_by}
                                message={"Employee is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <span className="edit-label">
                                Remarks
                                <span className="edit-optional px-2">
                                    (Optional)
                                </span>
                            </span>
                            <Form.Control
                                type="text"
                                name="remarks"
                                className="nc-modal-custom-input"
                                value={addDetails.remarks}
                                onChange={(e) => handleAddChange(e)}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <span className="edit-label mb-2">
                            Particulars{" "}
                            <label className="badge-required">{` *`}</label>
                        </span>
                        <div className="edit-purchased-items">
                            {items.length === 0 ? (
                                <span>No Particular Found!</span>
                            ) : (
                                renderTable()
                            )}
                            <InputError
                                isValid={isError.itemList}
                                message={
                                    "You must add at least 1 item"
                                }
                            />
                        </div>
                        </Col>
                    </Row>
                    <Row className="pt-3 PO-add-item">
                        <Col>
                            <Button
                                type="button"
                                onClick={() => handleAddItem()}
                                // disabled={branchValue.value === "" ? true : false}
                            >
                                Add Item
                            </Button>
                        </Col>
                    </Row>
                    {/* <Row className="align-right py-3">
                        <Col xs={2} className="text-end">
                            <span className="edit-label color-gray grand-total-text">
                                Grand Total
                            </span>
                        </Col>
                        <Col xs={1} className="text-end">
                            <span className="edit-label align-middle grand-total-text">
                                PHP
                            </span>
                        </Col>
                        <Col xs={3} className="text-end">
                            <span className="edit-label align-middle grand-total-text">
                                {"PHP " + numberFormat(addDetails.grand_total)} 
                            </span>
                        </Col>
                    </Row> */}
                    <Row className="mt-4 pt-3">
                        <Col xs={12}>
                            <Dragger
                                fileList={fileList}
                                onRemove={handleRemove}
                                beforeUpload={handleBeforeUpload}
                                multiple={false}
                                listType="picture"
                                progress={{ showInfo: true }}
                            >
                                <img src={upload} className="cursor-pointer" />
                                <p className="ant-upload-text">
                                    Click or drag file to this area to upload
                                </p>
                            </Dragger>
                        </Col>
                    </Row>

                    {/* <Row className="align-right pt-3">
                            <Col xs={2} className="text-end">
                                <span className="edit-label color-gray">
                                    Subtotal
                                </span>
                            </Col>
                            <Col xs={1} className="text-end">
                                <span className="edit-label align-middle">
                                    PHP
                                </span>
                            </Col>
                            <Col xs={3} className="text-end">
                                <span className="edit-label align-middle">
                                    {numberFormat(addDetails.subtotal)}
                                </span>
                            </Col>
                        </Row>
                    <Row className="align-right pt-3">
                        <Col xs={2} className="text-end">
                            <span className="edit-label color-gray">
                                Delivery/Service Fee
                            </span>
                        </Col>
                        <Col xs={1} className="text-end">
                            <span className="edit-label align-middle">PHP</span>
                        </Col>
                        <Col xs={3}>
                            <Form.Control
                                type="number"
                                name="service_fee"
                                min={0}
                                step="0.01"
                                className="align-middle nc-modal-custom-text"
                                onChange={(e) => handleAddChange(e)}
                            />
                        </Col>
                    </Row>

                    <Row className="align-right pt-3">
                        <Col xs={2} className="text-end">
                            <span className="edit-label color-gray">
                                Discount
                            </span>
                        </Col>
                        <Col xs={1} className="text-end">
                            <span className="edit-label align-middle">PHP</span>
                        </Col>
                        <Col xs={3}>
                            <Form.Control
                                type="number"
                                name="discount"
                                min={0}
                                step="0.01"
                                className="align-middle nc-modal-custom-text"
                                onChange={(e) => handleAddChange(e)}
                            />
                        </Col>
                    </Row> */}

                    
                    <div className="d-flex justify-content-end pt-5 pb-3">
                        <button
                            type="button"
                            className="button-secondary me-3"
                            onClick={() => navigate(-1)}
                        >
                            Cancel
                        </button>
                        {/* {
                            addDetails.status === "pending" && (
                                <> */}
                                {isClickedSave ? (
                                    <div className="button-tertiary me-3 d-flex justify-content-center">
                                        <ReactLoading
                                            type="bubbles"
                                            color="#FFFFFF"
                                            height={50}
                                            width={50}
                                        />
                                    </div>
                                ) : (
                                    <button
                                        type="button"
                                        className="button-tertiary me-3"
                                        onClick={handleSave}
                                    >
                                        Save
                                    </button>
                                )}
                                {/* </>
                            )
                        } */}
                        {isClicked ? (
                            <div className="button-primary d-flex justify-content-center">
                                <ReactLoading
                                    type="bubbles"
                                    color="#FFFFFF"
                                    height={50}
                                    width={50}
                                />
                            </div>
                        ) : (
                            <button
                                type="button"
                                className="button-primary"
                                onClick={handleSubmit}
                            >
                                Submit
                            </button>
                        )}
                    </div>
                </div>
            </div>
            <FileExceedModal
                show={showFileExceedModal}
                onHide={() => setShowFileExceedModal(false)}
                size="2MB"
            />
            <Footer/>
        </div>
    );

}

export default AddPurchaseRequest;
